type GetAppScopeHookType = {
  appScope: string;
};

export const useGetAppScope = (): GetAppScopeHookType => {
  const appScope = process.env.REACT_APP_SCOPE || 'ERP';

  return { appScope };
};
